import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.VisualDescription`]: `Visual Description`,
      [`${prefix}.Preparation.DynamicConePenetrometer`]: `Cone Penetrometer`,
      [`${prefix}.Preparation.PenetrationDepthMeasuredBy`]: `Measurement By`,
      [`${prefix}.Preparation.Measure`]: `Measure`,
      [`${prefix}.Preparation.MeasurementAtZeroBlows`]: `Measurement at Zero Blows`,
      [`${prefix}.Preparation.GraduationInterval`]: `Graduation Interval`,
      [`${prefix}.Preparation.ReducedLevelToLayer`]: `Reduced Level to Layer`,
      [`${prefix}.Preparation.SurfaceLevelToLayer`]: `Surface Level to Layer`,
      [`${prefix}.Preparation.RecordGroundWaterTableLocation`]: `Record ground water table location`,
      [`${prefix}.Preparation.GroundWaterTableDepth`]: `Ground Water Table Depth`,
      [`${prefix}.Preparation.MoistureCondition`]: `Moisture Condition`,
      [`${prefix}.Preparation.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent`]:
        'Moisture Content',

      [`${prefix}.Measurements.ResultNotObtainable`]: `Result not obtainable`,
      [`${prefix}.Measurements.ResultNotObtainableReason`]: `Reason`,
      [`${prefix}.Measurements.UnableToPenetrateFurther`]: `Unable to penetrate further`,
      [`${prefix}.Measurements.TestCompletion`]: `Test Completion`,

      [`${prefix}.Measurements.Measurements.Blows`]: `Blows`,
      [`${prefix}.Measurements.Measurements.TotalBlows`]: `Total Blows`,
      [`${prefix}.Measurements.Measurements.PenetrationReading`]: `Penetration Reading`,
      [`${prefix}.Measurements.Measurements.Penetration`]: `Penetration`,
      [`${prefix}.Measurements.Measurements.Depth`]: `Depth`,

      [`${prefix}.Results.JoinLayersOnChart`]: `Include regression lines on chart`,
      [`${prefix}.Results.StartDepth`]: `Start Depth`,
      [`${prefix}.Results.FinalDepth`]: `Final Depth`,
      [`${prefix}.Results.PenetrationResistanceCheck`]: `Penetration Resistance`,
      [`${prefix}.Results.PenetrationResistance`]: `Penetration Resistance`,
      [`${prefix}.Results.DepthToMidpoint`]: `Depth to Midpoint`,
      [`${prefix}.Results.BlowsPerGraduationInterval`]: `Blows Per Graduation Interval`,
      [`${prefix}.Results.BlowsPerGraduationIntervalCheck`]: `Blows Per Graduation Interval`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent`]: '%',
    })
  );

export default getLabelConfig;
